import request from "@/api";
import type { ValidatePhone } from "@/entity/login";
import type { UserVo } from "@zhihaoscm/entity";

export const loginService = {
    getUserInfo: async (): Promise<UserVo> => {
        const { data } = await request.service.get(`/admin/login/me`);
        return data;
    },
    loginPhone: async (params: ValidatePhone): Promise<{ accessToken: string }> => {
        const { data } = await request.service.post(`/admin/login/mobile`, params);
        return data;
    },
    enterpriseWeChatLogin: async (params: {
        code: string;
        source?: string;
        url?: string;
    }): Promise<{ accessToken: string }> => {
        const { data } = await request.service.get(`/admin/login/wxw`, { params });
        return data;
    }
};
